"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DOCKET_ENTRY_ADDED = exports.PACER_DOCKET_ENTRIES_UPDATED = exports.PACER_DOCKET_ENTRIES_SCRAPE_FINISH = exports.PACER_DOCKET_ENTRIES_SCRAPE_START = exports.PACER_CASE_SEARCH_FOUND = exports.PACER_CASE_SEARCH_FINISH = exports.PACER_CASE_SEARCH_START = void 0;
exports.PACER_CASE_SEARCH_START = "pacerCaseSearchStart";
exports.PACER_CASE_SEARCH_FINISH = "pacerCaseSearchFinish";
exports.PACER_CASE_SEARCH_FOUND = "pacerCaseSearchFound";
exports.PACER_DOCKET_ENTRIES_SCRAPE_START = "pacerDocketEntriesScrapeStart";
exports.PACER_DOCKET_ENTRIES_SCRAPE_FINISH = "pacerDocketEntriesScrapeFinish";
exports.PACER_DOCKET_ENTRIES_UPDATED = "pacerDocketEntriesUpdated";
exports.DOCKET_ENTRY_ADDED = "docketEntryAdded";